import { apiGet, apiPut } from 'utils/http';

const customerAPI = {
  getCustomer: async ({ customerId }) => {
    return apiGet(`/merchant/customers/${customerId}`);
  },
  getCustomers: async ({ page, pageSize }) => {
    return apiGet('/merchant/customers', {
      query: {
        offset: page * pageSize,
        pageSize,
      },
    });
  },
  getSessionAlerts: async () => {
    return apiGet('/merchant/customers/sessions/alerts');
  },
  getSession: async ({ sessionId }) => {
    return apiGet(`/merchant/customers/sessions/${sessionId}`);
  },
  getSessions: async ({ page, pageSize, filters }) => {
    return apiGet('/merchant/customers/sessions', {
      query: {
        offset: page * pageSize,
        pageSize,
        ...filters,
      },
    });
  },
  getCreditDecisionDetails: async ({ requestReference }) => {
    return apiGet(`/merchant/customers/credit/${requestReference}/details`);
  },
  actions: {
    setCreditDecision: async ({ sessionId, decision, limit }) => {
      const body = { decision, limit };
      return apiPut(`/merchant/customers/sessions/${sessionId}/credit_decision`, { body });
    },
    setIdentityVerification: async ({ sessionId, decision }) => {
      const body = { decision };
      return apiPut(`/merchant/customers/sessions/${sessionId}/identity_verification`, { body });
    },
  },
};

export { customerAPI };
